import { useEffect, useState } from 'react';
import { getYourPurchasesCard } from '../cardDefinitions';
import { IFrameCardProps } from '../FrameCardTemplate';

interface Props {
  translate: any;
  language: string;
  canUseFeatureFlag: boolean;
  isLoading: boolean;
  isSubscriptionsLoading?: boolean;
  onError: () => void;
}

export function useLoadYourPurchasesCard({
  translate,
  language,
  canUseFeatureFlag,
  isLoading,
  onError
}: Props): { resolved: boolean; card: IFrameCardProps | null } {
  const [resolved, setResolved] = useState(false);
  const [card, setCard] = useState<IFrameCardProps | null>(null);

  useEffect(() => {
    if (!canUseFeatureFlag) return;

    let isMounted = true;

    (async () => {
      try {
        const result = await getYourPurchasesCard(
          translate,
          language,
          canUseFeatureFlag,
          isLoading
        );
        if (isMounted && result) {
          setCard(result);
        }
      } catch (error) {
        if (isMounted) {
          onError();
        }
      } finally {
        if (isMounted) setResolved(true);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [translate, language, canUseFeatureFlag, isLoading, onError]);

  return { resolved, card };
}
